module.exports = __webpack_public_path__ + "img/art_1_2.f155fe83.jpeg";